import React from "react";
import PropTypes from "prop-types";
import { Card, Box } from "@mui/material";

import MDBox from "shared/components/MDBox";
import TableAseguramientoContent from "../TableAseguramiento/TableAseguramientoContent";

const HeaderAseguramiento = ({ refreshFlag, onError }) => {
  return (
    <MDBox position="relative" sx={{ py: 1 }}>
      <Card
        sx={{
          mt: 1,
          mx: 0,
          py: 2,
          px: 2,
          borderRadius: 3,
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          overflow: "hidden",
        }}
      >
        {/* Solo la tabla, sin nada más */}
        <Box>
          <TableAseguramientoContent refreshFlag={refreshFlag} onError={onError} />
        </Box>
      </Card>
    </MDBox>
  );
};

HeaderAseguramiento.defaultProps = {
  refreshFlag: false,
  onError: null,
};

HeaderAseguramiento.propTypes = {
  refreshFlag: PropTypes.bool,
  onError: PropTypes.func,
};

export default HeaderAseguramiento;
